import store from '@/store'
import createdAt from '@/core/components/createdAt'

export default {
  // 成品附加费
  className: 'surcharge',
  // fields: [
  //   {
  //     name: 'model',
  //     note: '型号'
  //   },
  //   {
  //     name: 'proportion',
  //     note: '含量'
  //   },
  //   'incidental',
  //   'profit'
  // ],
  mixin: {
    actionWidth: 120,
    fields: [

      {
        name: 'model',
        note: '型号',
      },
      {
        name: 'proportion',
        note: '含量'
      },
      'incidental',
      'profit',
      {
        name: 'createdAt',
        width: 120,
        view: {
          component: createdAt
        },
        disabled: true
      },
      'updatedAt'
    ],
    search: [
      'model',
      'createdAt',
      'updatedAt'
    ],
    action: {
      edit: store.state.user && store.state.user.authority.finishSurcharge.edit
        ? {
          type: 'row',
          text: '编辑', // 按钮上的文字
          buttonType: 'primary', // 按钮的类型
          component: 'akModelEditor'
        } : false,
      delete: store.state.user && store.state.user.authority.finishSurcharge.del ? {
        type: 'row',
        text: '删除',
        callback: async ({ record, vm, modelName }) => { // 点击按钮后触发的callback回调，参数中的 record代表被点击行的数据，vm为vue实例
          await vm.confirm('警告', '你确定要删除这条记录吗?')
          let rs = await vm.$modelAjax.delete(modelName, record.objectId).catch(() => {
            this.$notification['error']({
              message: '网络错误',
              description: '删除数据失败'
            })
          })
          if (rs) {
            vm.$notification['success']({
              message: '操作成功',
              description: '记录已被删除'
            })
            vm.refresh() // 你可以调用refresh与reset方法来刷新页面，区别为reset会重置查询条件，排序，翻页页数
          }
        }
      } : false
    }
  },
  hooks: {
    beforeFetch ({ where }) {
      where.type = 'finish'
      if (store.state.user.allShopManagements === 'Yes') { } else {
        where.workShop = {
          $in: store.state.user.shopManagements
        }
      }
      // if (store.state.user.adminRole === 'workshop') {
      // where.workShop = {
      //   $in: store.state.user.shopManagements
      // }
      // }
    },
    beforeInsert ({ data }) {

    }
  },
}
